import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";

export const validateDate = ({
  fieldValue,
  inputValue,
}: {
  fieldValue: string;
  inputValue: Date;
}): Promise<void> => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const maxDate = new Date("3000-12-31");

  if (!fieldValue || (inputValue >= today && inputValue <= maxDate)) {
    return Promise.resolve();
  }

  return Promise.reject(
    "Укажите дату не позднее сегодняшнего дня и не позже 3000 года."
  );
};

export const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  return current && current < dayjs().startOf("day");
};
